module.exports = __webpack_public_path__ + "static/media/tushar_2.7d466467.png";